<template>
  <div>
    <base-info ref="baseInfo" v-model="form" :new-contract="newContract" />
    <product-list
      ref="product"
      :rebate-amount="form.rebateAmount"
      :communication-order-discount="form.communicationOrderDiscount"
      :sales-type="form.salesType"
      :rebate="form.rebate"
      :contract-id="form.customerContractNum"
      :contract-type="form.contractType"
      :form="form"
      @chooseAddress="(val)=>{ form.receiptAddressId = val.id }"
    />
    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <el-button type="primary" :loading="loading" @click="submit(0)">
          发布合同
        </el-button>
        <el-button type="default" :loading="loading" @click="submit(1)">
          保存草稿
        </el-button>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import baseInfo from './baseInfo';
// import productList from '../productList';
import productList from './productList/index';
import { saveOrderContractInfo, createContractNum } from '@/API';
import { buildContractComplianceRequest, checkExportCompliance } from '@/libs/exportCompliance';
// import eventBus from '../../../../libs/eventBus';
export default {
  data () {
    return {
      newContract: 'newContract',
      form: {
        contractNum: '',
        customerContractNum: '',
        isOrderAdminCreate: true,
        supplyUnitId: 2,
        supplyUnit: '锐捷网络股份有限公司',
        supplyAddress: '福州市金山大道618号桔园洲标准厂房22',
        supplyPhone: '',
        orderUnitCode: '',
        orderUnit: '',
        paymentBankId: '',
        orderUnitPhone: '',
        finalCustomer: '',
        saleTypeCode: '',
        saleTypeName: '',
        finalCustomerEmail: '',
        customerContractType: '',
        applicationScenariosCode: '',
        applicationSceneCode: '',
        salesType: 1,
        netSales: '',
        shipType: 2,
        rebate: 1,
        isTestProject: 0,
        paymentMethodName: '立即',
        currencyId: 'CNY',
        contractTypeCode: '09',
        contractType: '新建订单合同',
        isRebate: false,
        unitAbbreviation: '福州'
      },
      loading: false
    };
  },
  components: {
    baseInfo,
    productList
  },
  computed: {},
  methods: {
    async submit (val) {
      if (!this.$refs.baseInfo.form.regionCode) {
        this.$message.error('请填写区域');
        return;
      }
      let baseR = true;
      let Product = {};

      if (!val) {
        baseR = await this.$refs.baseInfo.validate();
        if (!baseR) return;
        baseR.contractInfo.isDraft = false;
      } else {
        baseR = this.$refs.baseInfo.validatedrafts();
        if (!baseR) return;
        baseR.contractInfo.isDraft = true;
      }
      // eventBus.$emit('btnType', val);

      if (val) {
        Product = await this.$refs.product.validatedrafts();
      } else {
        Product = await this.$refs.product.validate();
      }

      if (baseR && Product) {
        val ? baseR.contractInfo.isDraft = true : baseR.contractInfo.isDraft = false;
        baseR.contractDetail.actualSettlementAmount = Product.actualSettlementAmount;
        baseR.invoiceEmail = this.$refs.baseInfo.form.invoiceEmail; // 电票邮箱字段
        baseR.contractDetail.orderSales = Product.orderSales;
        // baseR.contractDetail.netSales = baseR.netSales;
        this.loading = true;
        Product.productList.forEach((item) => {
          item.authorizationEmail = baseR.contractDetail.authorizationEmail;
        });
        if (!val) {
          const decision = await checkExportCompliance(this,
            buildContractComplianceRequest(this.form, baseR, Product.productList, this.$refs.product.address));
          if (!decision.allowBusiness) {
            this.loading = false;
            return;
          }
        }
        saveOrderContractInfo({ ...baseR, contractProductInfos: Product.productList }).then((res) => {
          let json = res.data;
          this.loading = false;
          if (json.status === '200') {
            if (val) {
              this.$router.replace({ name: 'orderPersionDrafts' });
            } else {
              this.$router.replace({ name: 'orderPersionContractList' });
            }
          }
        }).catch(() => {
          this.loading = false;
        });
      }
    },
    createContractNumInitialize () {
      createContractNum('福州', '新建订单合同', '').then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.form.contractNum = json.data;
          this.form.customerContractNum = json.data;
        }
      }).catch((res) => {

      });
    }
  },
  mounted () {
    this.createContractNumInitialize();
  }
};
</script>
<style lang="scss" scoped>
</style>
